export default __webpack_public_path__ + "static/media/logo-svh.1c7880cd.svg";